<template>
  <div>
    <h6 v-if="used !== total">
       <span>
         {{ $t('components.remaining.remaining_quota') }}:
         <span class="badge pt-1"
               :class="{
                   'badge-danger' : used === total,
                   'badge-info' : !(used === total)
                       }">
           {{ remainingQuota }}
         </span>
       </span>
    </h6>
    <h5 v-else>
         <span class="mb-3 badge badge-soft-secondary py-2">
             <span>
                  {{ $t('components.remaining.no_more') }}
             </span>
              <a
                  @click="$router.push({name:'settings', query:  {tab: 'subscription', tm: + new Date()}})"
                  href="javascript: void(0);">
                <i class="mdi mdi-arrow-up-circle-outline"></i>
                {{ $t('components.remaining.upgrade') }}
              </a>
         </span>
    </h5>
  </div>
</template>

<script>
export default {
  name: "Remaining",
  props: {
    used: {
      type: Number,
      default: 0
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    remainingQuota() {
      return this.total - this.used
    }
  }
}
</script>

<style scoped>

</style>